<template>
  <div>
    <div class="button-area" v-if="progress == 1 && type != 'write'">
      <div class="button" style="background: #5DBF39" @click="study = 1;flag = true;toProgress(2)">认识</div>
      <div class="button" @click="study = 2;toProgress(2)">不确定</div>
      <div class="button" @click="study = 3;toProgress(2)" style="background: #BF3939">不认识</div>
    </div>
    <div class="button-area" v-if="progress == 2">
      <div v-if="flag" class="button" @click="flag = false;toProgress(1);wordOver()" style="background: #5DBF39">认对了</div>
      <div v-if="flag" class="button" @click="study = 3;flag = false;toProgress(1);wordOver()" style="background: #BF3939">认错了</div>
      <div v-if="!flag" class="button" @click="toProgress(1);wordOver()">下一个</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['progress','type'],
  data() {
    return {
      flag: false,
      study: 0,
    }
  },
  methods: {
    toProgress(num) {
      this.$emit('progressChange',num)
    },
    wordOver() {
      this.$emit('wordOver',this.study)
      this.study = 0;
    }
  }
}
</script>

<style scoped>
.button{
  width: 160px;
  height: 45px;
  padding: 15px;
  font-size: 2em;
  margin: 10px auto;
  background: #334970ee;
  color: white;
  text-align: center;
  border-radius: 50px;
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
}
.button-area{
  margin: 75px 0;
  height: 400px;
  /* background: #fff; */
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
@media screen and (max-height: 1400px){
  .button{
    width: 160px;
    height: 45px;
    padding: 15px;
    font-size: 2em;
    margin: 10px auto;
    background: #334970ee;
    color: white;
    text-align: center;
    border-radius: 50px;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
  }
  .button-area{
    margin: 40px 0;
    height: 350px;
    /* background: #fff; */
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}
</style>
